import auth from '@/mixins/auth'
import componentState from '@/mixins/component-state'

import attachments from './attachments'
import unsavedAttachments from './unsaved-attachments'
import annotate from './annotate'

import breakpoints from '@/libs/breakpoints'
import imageProxy from '@/libs/image-proxy'

export default {
  mixins: [auth, componentState, attachments, unsavedAttachments, annotate],

  data: function () {
    return {
      body: '',
      error: '',
      saving: false,
      saved: false,
      focusInput: false,
      seenText: false,
      priority: 0,
      edited: false,
      isCancelling: false
    }
  },

  computed: {
    isTouch: function () {
      return breakpoints.isTouch()
    },
    isMobile: function () {
      return breakpoints.isMobile()
    },
    entityID: function () {
      return this.entity ? this.entity.id : null
    },
    emptyBody: function () {
      return !this.body.length
    },
    postContext: function () {
      if (this.update) {
        return `${this.context}-update`
      } else {
        return `${this.context}`
      }
    },
    postContextClass: function () {
      return `create-${this.postContext}`
    },
    userName: function () {
      return this.currentUser.userName
    },
    avatar: function () {
      return imageProxy.thumbnail(this.currentUser.avatar)
    },
    isEngStaff: function () {
      return this.currentUser ? this.currentUser.isEngStaff : false
    }
  },

  watch: {
    saving: function () {
      this.$emit('saving', this.saving)
    }
  },

  mounted: function () {
    const storedData = this._get(this.createKey, this.data)
    if (storedData) {
      this.body = storedData.body
      this.attachments = storedData.attachments
      this.uploadedAttachments = storedData.uploadedAttachments
      this.seenText = storedData.seenText
    } else if (this.update) {
      this.body = this.entity.body
      this.attachments = this.entity.attachments.slice(0)
    }

    if (this.postContext === 'post' || this.projectType === 'story') {
      this.seenText = true
    }
  },

  methods: {
    reset: function () {
      this.body = ''
      this.error = ''
      this.attachments = []
      this.uploadedAttachments = 0
      this.saving = false
      this.focusInput = false
      this.priority = 0
    },

    toggleFocus: function () {
      this.focusInput = !this.focusInput
    }
  },

  beforeDestroy: function () {
    this.seenText = false

    if (this.saved || this.isCancelling) {
      this.isCancelling = false
      this._delete(this.createKey)
      this.saved = false
    } else {
      this._set(this.createKey, this.getStoreData())
    }
  }
}
